import { useEffect } from 'react';

import { useUserState } from 'src/contexts/UserContext';
import { onboardingSurveyTypeformId } from './Welcome.const';

interface TypeformPopup {
  open: () => void;
  close: () => void;
  unmount: () => void;
}

interface TypeformPopupOptions {
  hidden?: Record<string, string>;
  size?: number;
  opacity?: number;
  iframeProps?: Record<string, string>;
}

declare global {
  interface Window {
    tf?: {
      createPopup: (formId: string, options?: TypeformPopupOptions) => TypeformPopup;
    };
  }
}

const typeformEmbedUrl = 'https://embed.typeform.com/next/embed.js';
const typeformPopupCssUrl = 'https://embed.typeform.com/next/css/popup.css';

const loadTypeformEmbed = () => new Promise<void>((resolve, reject) => {
  if (window.tf) {
    resolve();
    return;
  }
  if (!document.querySelector(`link[href="${typeformPopupCssUrl}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = typeformPopupCssUrl;
    document.head.appendChild(link);
  }
  let script = document.querySelector<HTMLScriptElement>(`script[src="${typeformEmbedUrl}"]`);
  if (!script) {
    script = document.createElement('script');
    script.src = typeformEmbedUrl;
    script.async = true;
    document.body.appendChild(script);
  }
  script.addEventListener('load', () => resolve());
  script.addEventListener('error', reject);
});

export const useOnboardingSurvey = () => {
  const { user } = useUserState();
  const { id: userId, email } = user;
  const firstName = user.name.trim().split(' ')[0] ?? '';

  useEffect(() => {
    let popup: TypeformPopup | undefined;
    let cancelled = false;

    loadTypeformEmbed()
      .then(() => {
        if (cancelled || !window.tf) {
          return;
        }
        // Mirrors the live embed settings configured in Typeform:
        popup = window.tf.createPopup(onboardingSurveyTypeformId, {
          size: 70,
          opacity: 100,
          iframeProps: { title: 'Witamy w PortalYogi' },
          hidden: {
            first_name: firstName,
            email,
            user_id: String(userId),
          },
        });
        popup.open();
      })
      .catch(() => {
        // The survey is optional, the welcome view works without it.
      });

    return () => {
      cancelled = true;
      popup?.unmount();
    };
  }, [userId, email, firstName]);
};
